import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

import { environment } from '../../environments/environment';
import { ApiUrl } from '../custom-services/api-url/api-url';
import { ApiService } from '../custom-services/ApiService';
import { DataService } from '../service/data.service';

@Component({
    selector: 'app-e-ledger-login',
    templateUrl: './e-ledger-login.component.html',
    styleUrls: ['./e-ledger-login.component.css'],
    standalone: false
})
export class ELedgerLoginComponent implements OnInit {

  userEtin: any;
  userName: any;
  token: any;
  isLoggedIn: any;

  stopListening: Function;
  apiService: ApiService;
  eReturnPortalBaseUrl: string;
  eLedgerPortalBaseUrl: string;
  apiUrl: ApiUrl;
  eReturnServiceUrl : any;


  requestSessionID : any;
  refresh_token:any;

  isTokenExists : boolean = false;
  tokenData: any;
  sessionInfo: any;

  constructor(private renderer: Renderer2,
    private jwtHelper: JwtHelperService,
    apiService: ApiService,
    private activeRoutes: ActivatedRoute,
    apiUrl: ApiUrl,
    private router: Router,
    private dataService: DataService
    ) {
    // this.stopListening =
    //   renderer.listen('window', 'message', this.handleMessage.bind(this));
      this.apiService = apiService;
      this.apiUrl = apiUrl;
  }

  ngOnInit(): void {
    this.apiUrl.getUrl().subscribe(res => {
      this.eReturnPortalBaseUrl = res['eReturnPortalUrl']?.url;
      this.eLedgerPortalBaseUrl = res['eLedgerPortalUrl']?.url;
      this.eReturnServiceUrl = res['eReturnPortal']?.url;
      this.getQueryParams();
    });
    //this.isLoggedIn = 'not logged in';
    // localStorage.removeItem('token');
    //localStorage.setItem('isLogged', this.isLoggedIn);

    //
    this.activeRoutes.queryParams.subscribe(params => {
      if(params['token_info']){
        this.tokenData = JSON.parse(atob(params['token_info']));
        this.token = this.tokenData.token;
        this.refresh_token = this.tokenData.refresh_token;
        this.checkToken();
      }
      else if(params['session_id']){
        this.requestSessionID = (params['session_id']);
        this.getNewTokenForFiling();
      }
    });
  }

  getQueryParams() {
    this.activeRoutes.queryParams.subscribe(async params => {
      if (params['sessionInfo']) {
        try {
          // URL decode first (if needed)
          const encryptedData = decodeURIComponent(params['sessionInfo']);
          // Decrypt and decompress
          let paramsInfo = JSON.parse(atob(encryptedData));
          this.sessionInfo = {
            sessionId: paramsInfo.split('|')[0],
            tin: paramsInfo.split('|')[1]
          };
          console.log('sessionInfo', this.sessionInfo);
          this.getTokenInfo();
        } catch (error) {
          console.error('Error decrypting session info:', error);
        }
      }
      else if(params['session_id']){
        this.requestSessionID = (params['session_id']);
        this.getNewTokenForFiling();
      }
    });
  }

  getTokenInfo() {
    this.apiService.get(environment.taxpayer_base_url + '/filingservice/v3/api/session/get/' + this.sessionInfo.tin + '/' + this.sessionInfo.sessionId)
    .subscribe(res=>{
      this.token = res.token;
      this.refresh_token = res.refreshToken;
      this.dataService.updateData('CURRENT_ASSESSMENT_YEAR', res.assessmentYear);
      this.checkToken();
    })
  }

  handleMessage(event: Event) {
    const message = event as MessageEvent;

    // Only trust messages from the below origin.
    if (message.origin !== this.eLedgerPortalBaseUrl) return;

    this.token = message.data;
    if (this.token != null) {
      localStorage.setItem('token', this.token);
      let tokenInfo = this.jwtHelper.decodeToken(this.token)['claims'];
      this.userEtin = tokenInfo['userIdentity'];
      localStorage.setItem('tin', this.userEtin);
      this.userName = tokenInfo['userFullName'];
      localStorage.setItem('name', this.userName);

      // this.isLoggedIn = 'logged in';
      // localStorage.setItem('isLogged', this.isLoggedIn);

    }
    else{
      window.location.href = this.eReturnPortalBaseUrl + '/#/landing-page';
    }
  }

  getNewTokenForFiling()
  {
    this.apiService.get(environment.taxpayer_base_url + '/ledgerservice/v3/api/redirect/'+this.requestSessionID)
      .subscribe(result => {
        if (result.success) {
          this.token = result.replyMessage.token_id;
          this.refresh_token = result.replyMessage.refresh_token;
          this.checkToken();
        }

      },
        error => {

          console.log(error['error'].errorMessage);
        });

  }

  // ngOnDestroy() {
  //   this.stopListening();
  // }

  checkToken(){
    localStorage.setItem('refresh_token', this.refresh_token);
    localStorage.setItem('token', this.token);
    let tokenInfo = this.jwtHelper.decodeToken(this.token)['claims'];
    this.userEtin = tokenInfo['userIdentity'];
    localStorage.setItem('tin', this.userEtin);
    this.userName = tokenInfo['userFullName'];
    localStorage.setItem('name', this.userName);

    // this.isLoggedIn = 'logged in';
    // localStorage.setItem('isLogged', this.isLoggedIn);
    this.isTokenExists = localStorage.getItem('token')? true : false;
    if(this.isTokenExists)
    {
       this.isLoggedIn = this.jwtHelper.isTokenExpired(localStorage.getItem('token'));
    }
    const departure = localStorage.getItem('departure');

    if (departure === 'SP') {
      this.router.navigate(['/user-panel/single-page-return']);
    } else if (departure === 'TP') {
      this.router.navigate(['/user-panel/tax-and-payment']);
    } else {
      this.router.navigate(['/user-panel/home']);
    }
  }

}
